<template>
	<div class="ppt-preview-page">
		<div class="ppt-container">
			<div class="ppt-content">

				<div class="ppt-preview-wrapper" v-if="pptUrl">
					<iframe
						class="ppt-content"
						:src="`${pptUrl}?ci-process=doc-preview&dstType=html`"
					></iframe>
				</div>

				<div class="loading-wrapper" v-else-if="loading">
					<van-loading type="spinner" color="#1989fa" size="24px"
						>加载中...</van-loading
					>
				</div>

				<div class="error-wrapper" v-else-if="error">
					<van-empty description="PPT加载失败" />
					<van-button
						type="primary"
						size="small"
						@click="retryLoadPPT"
						>重试</van-button
					>
				</div>
			</div>
		</div>

		<div class="footer">
			<van-button type="primary" block @click="handleDownloadPPT"
				>下载PPT</van-button
			>
		</div>

		<GeneratePptDialog ref="refGeneratePptDialog" />
	</div>
</template>

<script>
import GeneratePptDialog from "../result-list/components/generate-ppt-dialog.vue";

export default {
	components: {
		GeneratePptDialog,
	},
	data() {
		return {
			answerId: "",
			handleItem: {},
			refGeneratePptDialog: null,
			pptUrl: "",
			loading: false,
			error: false,
			pptUrlTest: "https://examples-1258125638.cos.ap-guangzhou.myqcloud.com/test.pptx",

		};
	},
	mounted() {
		this.answerId = this.$route.params.id;
		this.handleItem = {
			id: this.answerId,
		};
		this.getPPTUrl();
	},
	methods: {
		getPPTUrl() {
			this.loading = true;
			this.error = false;

			this.$api.surveys
				.getPPTUrl({
					id: this.answerId,
				})
				.then((res) => {
					if (!res.code && res.data) {
						this.pptUrl = res.data;
					} else {
						this.error = true;
						this.$toast(res.message || "获取PPT地址失败");
					}
				})
				.catch((err) => {
					console.error("获取PPT地址失败:", err);
					this.error = true;
					this.$toast("获取PPT地址失败");
				})
				.finally(() => {
					this.loading = false;
				});
		},
		retryLoadPPT() {
			this.getPPTUrl();
		},
		handleDownloadPPT() {
			this.$refs.refGeneratePptDialog.init(this.handleItem);
		},
	},
};
</script>

<style lang="less" scoped>
.ppt-preview-page {
	width: 100vw;
	height: 100vh;
	display: flex;
	flex-direction: column;
	background-color: #f5f5f5;
}

.ppt-container {
	flex: 1;
	overflow-y: auto;
	padding: 10px;
}

.ppt-content {
	max-width: 100%;
	margin: 0 auto;
}

.ppt-preview-wrapper {
	width: 100%;
	height: 85vh;
	overflow: hidden;
	background-color: #fff;
}

.ppt-content {
	border: none;
	outline: none;
	width: 100%;
	height: 100%;
	&::-webkit-scrollbar {
		display: none;
	}
}

.loading-wrapper,
.error-wrapper {
	height: 400px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	background-color: #fff;
	border-radius: 8px;
}

.error-wrapper {
	gap: 16px;
}

.footer {
	padding: 20px;
	background-color: #fff;
	border-top: 1px solid #eee;
}
</style>
